module.exports = __webpack_public_path__ + "img/banner3.691f1b21.png";